import { ImageCache } from '../../../Cache/ImageCache';
import { registerShortCircuitUrl } from '../../../Cache/ImageCache/ShortCircuit';

export const GlobalImageCache = {
    getCached(url: string): PromiseLike<string> {
        return ImageCache.getCached(url);
    },

    shortCircuitUrl(urlToShortCircuit: string, maximumAttempts: number): void {
        registerShortCircuitUrl(urlToShortCircuit, maximumAttempts);
    },
};
